module.exports = __webpack_public_path__ + "img/animate-1-1.dd2d77dd.png";